import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { SalesPage } from './components/SalesPage';
import { SalesPopup } from './components/SalesPopup';
import { LiveViewers } from './components/LiveViewers';
function initMetaPixel() {
  const pixelId = '1569146510855950';
  if (typeof window !== 'undefined' && !(window as any).fbq) {
    const f = window as any;
    const b = document;
    let n: any;
    const t = 'script';
    if (f.fbq) return;
    n = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const e = b.createElement(t) as HTMLScriptElement;
    e.async = true;
    e.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = b.getElementsByTagName(t)[0];
    s?.parentNode?.insertBefore(e, s);
    (window as any).fbq('init', pixelId);
    (window as any).fbq('track', 'PageView');
  }
}
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-[#FFF8F0]" data-id="element-0">
      <Header data-id="element-1" />
      <div className="pt-14" data-id="element-2">
        <LiveViewers data-id="element-3" />
      </div>
      <SalesPage data-id="element-4" />
      <SalesPopup data-id="element-5" />
    </div>;
}